module.exports = {
  STORE_SELECTED_LANGUAGE: 'STORE_SELECTED_LANGUAGE',
};
